import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, signal } from '@angular/core';

@Component({
  selector: 'zef-spinner-ai-words',
  template: `
    <span class="ai-words">{{ currentText() }}</span>
  `,
  styles: `
    :host {
      display: inline;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerAiWordsComponent implements OnInit, OnDestroy {
  private readonly words = [
    $localize`:ai spinner verb@@ai-spinner-word-processing:processing`,
    $localize`:ai spinner verb@@ai-spinner-word-thinking:thinking`,
    $localize`:ai spinner verb@@ai-spinner-word-analyzing:analyzing`,
    $localize`:ai spinner verb@@ai-spinner-word-reasoning:reasoning`,
    $localize`:ai spinner verb@@ai-spinner-word-evaluating:evaluating`,
    $localize`:ai spinner verb@@ai-spinner-word-synthesizing:synthesizing`,
    $localize`:ai spinner verb@@ai-spinner-word-generating:generating`,
    $localize`:ai spinner verb@@ai-spinner-word-computing:computing`,
    $localize`:ai spinner verb@@ai-spinner-word-probing:probing`,
    $localize`:ai spinner verb@@ai-spinner-word-reflecting:reflecting`,
    $localize`:ai spinner verb@@ai-spinner-word-interpreting:interpreting`,
  ];

  readonly currentText = signal(this.buildText());

  private intervalId: ReturnType<typeof setInterval> | null = null;

  ngOnInit(): void {
    this.intervalId = setInterval(() => {
      this.currentText.set(this.buildText());
    }, 5000);
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  private buildText(): string {
    const word = this.words[Math.floor(Math.random() * this.words.length)];
    return $localize`:ai spinner full text@@ai-spinner-full-text:AI is ${word}:word:...`;
  }
}
